"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * @fileoverview 函数相关
 * @author kirkzheng
 */

/**
* 空的辅助函数
*/
var noop = exports.noop = function noop() {};

/**
 * 防抖函数
 * @param {*} fn 待防抖的函数
 * @param {*} wait 延迟时间
 */
var debounce = exports.debounce = function debounce(fn, wait) {
    var callback = fn;
    var timerId = null;

    return function () {
        // 保存作用域
        var context = this;
        // 保存参数，例如 event 对象
        var args = arguments;

        clearTimeout(timerId);
        timerId = setTimeout(function () {
            callback.apply(context, args);
        }, wait);
    };
};

/**
 * 节流函数
 * @param {*} fn 待节流的函数
 * @param {*} threshold 节流时间
 * @param {*} scope this 对象
 */
var throttle = exports.throttle = function throttle(fn, threshold, scope) {
    var prev = Date.now();
    return function () {
        var context = scope || this,
            args = arguments;
        var now = Date.now();
        if (now - prev > threshold) {
            prev = now;
            fn.apply(context, args);
        }
    };
};

exports.default = {
    noop: noop,
    debounce: debounce,
    throttle: throttle
};